<template>
<div>
  <!-- NO APIK REGISTERED -->
  <div v-if="!apikRegistered">
    <p>{{ $t('beacon_management.no_beacon_registred') }}</p>
    <div class="go-to-beacon-id"
      @click="goToBeconSettings">
      <app-button-rect
        :text="$t('beacon_management.link_a_beacon')">
      </app-button-rect>
    </div>
  </div>
  <!-- AUTHORIZED -->
  <div v-else class="home">
    <app-main-user-info
      :totalDuration="getTotalTimeDay"
      :BeaconInfo="getBeaconShortID"
      :timeSheetStart="tsStart">
    </app-main-user-info>
    <div v-if="fetchingData" class="loader-at-start"></div>
    <div v-if="fetchingData">
      <p>{{ $t('timesheet.wait_api_key') }}</p>
    </div>
    <div v-if="!fetchingData">
      <app-add-button></app-add-button>
      <div v-for="(mo, idx) in getTimesheet" :key="idx">
        <app-time-row v-if="mo.productionArea && mo.productionArea !== 'unknown'"
          :manufacturingOrder="mo"
          :idx="idx"
          :totalTimeCollected="getTotalTimeCollected">
        </app-time-row>
        <app-add-button
          v-if="(!mo.productionArea || mo.productionArea === 'unknown') && previousRowIsNotAdd(idx)"
          :start="getTimesheet[idx - 1].end"
          :end="getTimesheet[idx + 1].start">
        </app-add-button>
      </div>
      <app-add-button v-if="addCreateEndBtn(30)"></app-add-button>
      <div class="timesheet-processing">
        <p>{{ $t('timesheet.processing_data') }}</p>
        <div>
          <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
      </div>
      <p @click="backToTop">{{ $t('timesheet.back_to_top') }}</p>
    </div>
  </div>
</div>
</template>

<script>
import MainUserInfo from '@/components/MainUserInfo.vue';
import TimeRow from '@/components/TimeRow.vue';
import AddButton from '../components/AddButton.vue';
import getDuration from '../mixins/getDuration';
import ButtonRect from '../components/ButtonRect.vue';

export default {
  name: 'home',
  components: {
    'app-main-user-info': MainUserInfo,
    'app-time-row': TimeRow,
    'app-add-button': AddButton,
    'app-button-rect': ButtonRect,
  },
  data() {
    return {
      apikRegistered: false,
      totalDuration: '_',
      data: [],
      tsStart: 0,
      fetchingData: true,
    };
  },
  created() {
    this.$store.dispatch('getProductionZones');
    const apik = this.$store.getters.getApiK;
    if ((apik) && (apik.enabled)) {
      this.apikRegistered = true;
    }

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'onUnvalidAPIkey') {
        this.apikRegistered = false;
      }
    });
  },
  watch: {
    getTimesheet() {
      this.fetchingData = false;
    },
    data(nVal) {
      if (nVal[0] && nVal[0].start) {
        this.tsStart = nVal[0].start;
      }
    },
  },
  computed: {
    getTimesheet() {
      return this.$store.getters.getTimesheet;
    },
    getTotalTimeDay() {
      const data = this.$store.getters.getTimesheet;
      if (data.length > 0 && data[0].start !== undefined) {
        return this.getDuration(data[0].start, data.slice(-1).pop().end);
      }
      return 0;
    },
    getTotalTimeCollected() {
      return this.$store.getters.getTotalcollected;
    },
    getBeaconShortID() {
      this.$store.dispatch('getOperatorTimesheet', this.$store.getters.getBeaconID);
      return this.$store.getters.getBeaconShortID;
    },
  },
  methods: {
    backToTop() {
      window.scrollTo(0, 0);
    },
    previousRowIsNotAdd(idx) {
      if (idx === 0 || idx === this.getTimesheet.length - 1) {
        return false;
      }
      if (idx > 0) {
        return this.getTimesheet[idx - 1].productionArea !== undefined;
      }
      return true;
    },
    addCreateEndBtn(limitMinutes) {
      if (this.getTimesheet.length === 0) {
        return false;
      }
      const lastItem = this.getTimesheet[this.getTimesheet.length - 1];
      const lastItemEnd = lastItem.end;
      const nowInSeconds = Math.floor((new Date().getTime()) / 1000);
      return (nowInSeconds - lastItemEnd) >= (60 * limitMinutes);
    },
    goToBeconSettings() {
      this.$router.push('beaconid');
    },
  },
  mixins: [getDuration],
};
</script>

<style scoped>
  .timesheet-processing {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    background-color: #d3d3d3;
  }

  .go-to-beacon-id {
    margin: 0 5% 0 5%;
  }

  .loader-at-start {
    height: 2px;
    width: 0%;
    background-color: lightskyblue;
    animation: 30s slidein infinite;
    animation-delay: 0.5s;
  }

  @keyframes slidein {
    0% { width: 0%; }
    100% { width: 100%; }
  }

  /*
   ***** 3 DOT ANIMATION *****
   */
   .lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 30px;
  }
  .lds-ellipsis div {
    position: absolute;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
</style>
